import { render, staticRenderFns } from "./CertSave587.vue?vue&type=template&id=744b6cb7&scoped=true&"
import script from "./CertSave587.vue?vue&type=script&lang=js&"
export * from "./CertSave587.vue?vue&type=script&lang=js&"
import style0 from "./CertSave587.vue?vue&type=style&index=0&id=744b6cb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744b6cb7",
  null
  
)

export default component.exports